module.exports = __webpack_public_path__ + "img/analytics-report-stream.4bde5397.png";